import { getDefaultViewName } from './getDefaultViewName';
export const getCustomOrDefaultViewName = (customViewName, viewPathUrl) => customViewName || getDefaultViewName(viewPathUrl);
//# sourceMappingURL=getCustomOrDefaultViewName.js.map